import AbstractProvidedClass from "../../../shared/AbstractProvidedClass";

export default class RemoveSpeciesFromElementAction extends AbstractProvidedClass {
    constructor(provider, element, species) {
        super(provider);

        this.element = element;
        this.species = species;
        this.label = this.element.labels.getSpeciesLabel(this.species.id);
        this.index = this.element.labels.getIndexOf(this.label);
    }

    finish() {
        this.element.removeSpecies(this.species);
        this.actions.finish();
    }

    undo() {
        this.element.addSpecies(this.species, true);
        this.element.labels.replace(this.label, this.index);
        this.ensureCorrectInfoTab();
    }

    redo() {
        this.element.removeSpecies(this.species);
        this.ensureCorrectInfoTab();
    }

    ensureCorrectInfoTab() {
        if (this.selection.length == 1 &&
            this.selection.first == this.element
        ) {
            this.getTab('info').setCurrentElement(this.element);
        }
    }
}
